/**
 * @generated SignedSource<<a62a8c3ac2f89ad26e6e6157ff576739>>
 * @relayHash 56ef614e4d6de957ce32f5f26a7824e5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/575.0.0-2026-09-01T06:52:53.596Z/useNotificationsDeleteTagsMutation

import { ConcreteRequest } from 'relay-runtime';
export type UserNotificationsTagEnum = "UNREAD" | "UNVIEWED" | "%future added value";
export type UserNotificationsDeleteTagsInput = {
  activityFeedTagIds?: ReadonlyArray<string | null> | null;
  clientMutationId?: string | null;
  conversationIds?: ReadonlyArray<string | null> | null;
  itemEventTagIds?: ReadonlyArray<string | null> | null;
  tag?: UserNotificationsTagEnum | null;
  userId?: string | null;
};
export type useNotificationsDeleteTagsMutation$variables = {
  input: UserNotificationsDeleteTagsInput;
};
export type useNotificationsDeleteTagsMutation$data = {
  readonly userNotificationsDeleteTags: {
    readonly __typename: "UserNotificationsDeleteTagsPayload";
  } | null;
};
export type useNotificationsDeleteTagsMutation = {
  response: useNotificationsDeleteTagsMutation$data;
  variables: useNotificationsDeleteTagsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserNotificationsDeleteTagsPayload",
    "kind": "LinkedField",
    "name": "userNotificationsDeleteTags",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useNotificationsDeleteTagsMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useNotificationsDeleteTagsMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "ferrum/575.0.0-2026-09-01T06:52:53.596Z/useNotificationsDeleteTagsMutation",
    "metadata": {},
    "name": "useNotificationsDeleteTagsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e6e18a118a80af81ab7f63d30b8999fa";

export default node;
